/** 对话状态 */
export enum EnumConversationStatus {
  /** 进行中 */
  pending = 1,
  /** 已完成 */
  done = 2,
}

/** 回答状态 */
export enum EnumAnswerStatus {
  /** 等待建立连接中 */
  waiting = 'waiting',
  /** 回答中 */
  answering = 'answering',
  /** 回答完成 */
  completed = 'completed',
}

/** 报告节点类型 */
export enum EnumReportNodeType {
  /** 指标 */
  metric = '指标',
  /** 任务 */
  task = '任务',
  user = '用户请求',
  /** 引言 */
  introduction = '引言',
  /** 摘要 */
  abstract = '摘要',
  /** 结论 */
  conclusion = '结论',
}

/** 对话过程中的消息类型 */
export enum EnumReportChatMessageType {
  /** 对话回复 */
  Response = 'Response',
  /** 中间过程 */
  Process = 'Process',
  /** 报告内容的流式输出切片 */
  Report_Body = 'Report_Body',
  /** 返回报告 */
  Report = 'Report',
  /** 历史记录 */
  History = 'History',
}

/** sse 事件类型 */
export enum EnumSseEventType {
  data = 'data',
  error = 'error',
  message = 'message',
  end = 'end',
}

/** 回复内容中节点的dataset-type */
export enum EnumResponseDatasetType {
  /** 数据集 */
  dataset = 'dataset',
}